import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'booleanValue' })
export class BooleanValuePipe implements PipeTransform {
  transform(value: boolean): string {
    return value == true ? 'Да' : 'Нет'
  };
}



// WEBPACK FOOTER //
// ./src/app/pipes/booleanValue.pipe.ts